var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createAction, createReducer, createSelector } from '@reduxjs/toolkit';
import { CardGridType, WarrantyOptionTypes } from '../types';
import { selectCurrentVehicleUrlQueryString } from './currentVehicle';
import { createAndHydrateCalculator, defaultDraftCalculatorId, deleteCalculator, hydrateFromCalculator, PaymentMethod, persistCalculatorToUrl, primaryCalculatorId, selectPaymentOptions, selectPrimaryCalculatorIncentiveOfferIdsParam, selectPrimaryCalculatorQueryString, } from './financialCalculators';
import { loyaltyPrimaryChanged, offersPrimaryChanged } from './offers';
import { INCLUDE_FEES_URL_PARAM, INCLUDE_TAXES_URL_PARAM, OFFER_KEYS_URL_PARAM } from '../../utils/constants';
export var assetType = {
    exterior: 'exterior',
    interior: 'interior',
};
export var initialState = {
    Global: {
        toastNotifications: [],
    },
    ConfigureBap: {
        currentAccessoryModalId: '',
        activeProgressBarItem: '',
        toastNotifications: [],
        currentDrawerState: 'half',
        currentViewMoreModalId: '',
        isCompareModalOpen: false,
        selectedSubCategory: { protections: '', accessories: '' },
    },
    TrimOverview: {
        selectedAssetsType: assetType.exterior,
        backStepUrl: {
            href: '',
            text: '',
        },
        trimName: '',
        modelName: '',
        nameBadge: undefined,
        interiorColorIsInvalid: false,
    },
    ModelCardGrid: {
        isActive: false,
    },
    TrimCardGrid: {
        isActive: false,
        nextStepUrl: {
            href: '',
            text: '',
        },
    },
    VehicleListFilters: {
        bodyTypes: {},
    },
    SummaryBar: {
        isPaymentCalculatorModalOpen: false,
    },
    SelectedDealerBanner: {
        dealerBannerHeight: 0,
    },
    SummaryPage: {
        isWarrantyOptionsModalOpen: false,
        isPriceBreakdownModalOpen: false,
        doShowRecommendedWarrantyChangedToast: false,
        warrantyOptionsModalKey: '',
        warrantyOptionsModalType: WarrantyOptionTypes.None,
        warrantyOptionsRecommendedWarranty: '',
    },
    LayoutService: {
        isSkipped: false,
        hasError: false,
        isTriggered: false,
    },
};
export var setCurrentAccessoryModalId = createAction('ui/setCurrentAccessoryModalId');
export var setCurrentViewMoreModalId = createAction('ui/setCurrentViewMoreModalId');
export var setActiveProgressBarItem = createAction('ui/setActiveProgressBarItem');
export var setCurrentDrawerState = createAction('ui/setCurrentDrawerState');
export var setSelectedSubCategory = createAction('ui/setSelectedSubCategory');
export var addConfigureBapToastNotification = createAction('ui/addConfigureBapToastNotification');
export var removeConfigureBapToastNotification = createAction('ui/removeConfigureBapToastNotification');
export var clearAllConfigureBapToastNotification = createAction('ui/clearAllConfigureBapToastNotification');
export var toggleSelectedAssetType = createAction('ui/toggleSelectedAssetType');
export var setSelectedAssetType = createAction('ui/updateSelectedAssetType');
export var setIsModelCardGridActive = createAction('ui/setIsModelCardGridActive');
export var setIsTrimCardGridActive = createAction('ui/setIsTrimCardGridActive');
export var setBodyTypeLabels = createAction('ui/addBodyTypes');
export var setIsCompareModalOpen = createAction('ui/setIsCompareModalOpen');
export var setIsPaymentCalculatorModalOpen = createAction('ui/setIsPaymentCalculatorModalOpen');
export var setDealerBannerHeight = createAction('ui/setDealerBannerHeight');
export var setBackStepUrl = createAction('ui/setBackStepUrl');
export var setTrimName = createAction('ui/setTrimName');
export var toggleWarrantyOptionsModal = createAction('ui/toggleWarrantyOptionsModal');
export var togglePriceBreakdownModal = createAction('ui/togglePriceBreakdownModal');
export var setWarrantyOptionsModalKey = createAction('ui/setWarrantyOptionsModalKey');
export var setWarrantyOptionsModalType = createAction('ui/setWarrantyOptionsModalType');
export var setWarrantyOptionsRecommendedWarranty = createAction('ui/setWarrantyOptionsRecommendedWarranty');
export var setModelName = createAction('ui/setModelName');
export var setInteriorColorIsInvalid = createAction('ui/setInteriorColorIsInvalid');
export var setIsLayoutServiceSkipped = createAction('ui/setIsLayoutServiceSkipped');
export var setLayoutServiceHasError = createAction('ui/setLayoutServiceHasError');
export var setLayoutServiceIsTriggered = createAction('ui/setLayoutServiceIsTriggered');
export var setTrimCardGridNextStepUrl = createAction('ui/setTrimCardGridNextStepUrl');
export var setNameBadge = createAction('ui/setNameBadge');
export var addGlobalToastNotification = createAction('ui/addGlobalToastNotification');
export var removeGlobalToastNotification = createAction('ui/removeGlobalToastNotification');
export var setShowRecommendedWarrantyChangedToast = createAction('ui/setShowRecommendedWarrantyChangedToast');
export var resetUIReducerSections = createAction('ui/resetUIReducerSections');
var ui = createReducer(initialState, function (builder) {
    builder
        .addCase(setCurrentAccessoryModalId, function (state, action) {
        state.ConfigureBap.currentAccessoryModalId = action.payload;
    })
        .addCase(setCurrentViewMoreModalId, function (state, action) {
        state.ConfigureBap.currentViewMoreModalId = action.payload;
    })
        .addCase(toggleSelectedAssetType, function (state) {
        var prev = state.TrimOverview.selectedAssetsType;
        if (prev === assetType.exterior) {
            state.TrimOverview.selectedAssetsType = assetType.interior;
        }
        else {
            state.TrimOverview.selectedAssetsType = assetType.exterior;
        }
    })
        .addCase(setSelectedAssetType, function (state, action) {
        state.TrimOverview.selectedAssetsType = action.payload;
    })
        .addCase(setActiveProgressBarItem, function (state, action) {
        state.ConfigureBap.activeProgressBarItem = action.payload;
    })
        .addCase(setCurrentDrawerState, function (state, action) {
        state.ConfigureBap.currentDrawerState = action.payload;
    })
        .addCase(setSelectedSubCategory, function (state, action) {
        state.ConfigureBap.selectedSubCategory = __assign(__assign({}, state.ConfigureBap.selectedSubCategory), action.payload);
    })
        .addCase(addConfigureBapToastNotification, function (state, action) {
        state.ConfigureBap.toastNotifications = __spreadArray(__spreadArray([], state.ConfigureBap.toastNotifications, true), [action.payload], false);
    })
        .addCase(removeConfigureBapToastNotification, function (state, action) {
        state.ConfigureBap.toastNotifications = state.ConfigureBap.toastNotifications.filter(function (_a) {
            var id = _a.id;
            return id !== action.payload;
        });
    })
        .addCase(clearAllConfigureBapToastNotification, function (state) {
        state.ConfigureBap.toastNotifications = [];
    })
        .addCase(setIsCompareModalOpen, function (state, action) {
        state.ConfigureBap.isCompareModalOpen = action.payload;
    })
        .addCase(setIsModelCardGridActive, function (state, action) {
        state.ModelCardGrid.isActive = action.payload;
        state.TrimCardGrid.isActive = !action.payload;
    })
        .addCase(setIsTrimCardGridActive, function (state, action) {
        state.TrimCardGrid.isActive = action.payload;
        state.ModelCardGrid.isActive = !action.payload;
    })
        .addCase(setBodyTypeLabels, function (state, action) {
        state.VehicleListFilters.bodyTypes = action.payload.reduce(function (acc, item) { return (__assign(__assign({}, acc), item)); }, {});
    })
        .addCase(setIsPaymentCalculatorModalOpen, function (state, action) {
        state.SummaryBar.isPaymentCalculatorModalOpen = action.payload;
    })
        .addCase(setDealerBannerHeight, function (state, action) {
        state.SelectedDealerBanner.dealerBannerHeight = action.payload;
    })
        .addCase(setBackStepUrl, function (state, action) {
        state.TrimOverview.backStepUrl = action.payload;
    })
        .addCase(setTrimName, function (state, action) {
        state.TrimOverview.trimName = action.payload;
    })
        .addCase(toggleWarrantyOptionsModal, function (state, action) {
        state.SummaryPage.isWarrantyOptionsModalOpen = action.payload;
    })
        .addCase(setWarrantyOptionsModalKey, function (state, action) {
        state.SummaryPage.warrantyOptionsModalKey = action.payload;
    })
        .addCase(setWarrantyOptionsModalType, function (state, action) {
        state.SummaryPage.warrantyOptionsModalType = action.payload;
    })
        .addCase(setWarrantyOptionsRecommendedWarranty, function (state, action) {
        state.SummaryPage.warrantyOptionsRecommendedWarranty = action.payload;
    })
        .addCase(togglePriceBreakdownModal, function (state, action) {
        state.SummaryPage.isPriceBreakdownModalOpen = action.payload;
    })
        .addCase(setModelName, function (state, action) {
        state.TrimOverview.modelName = action.payload;
    })
        .addCase(setInteriorColorIsInvalid, function (state, action) {
        state.TrimOverview.interiorColorIsInvalid = action.payload;
    })
        .addCase(setIsLayoutServiceSkipped, function (state, action) {
        state.LayoutService.isSkipped = action.payload;
    })
        .addCase(setLayoutServiceIsTriggered, function (state, action) {
        state.LayoutService.isTriggered = action.payload;
    })
        .addCase(setLayoutServiceHasError, function (state, action) {
        state.LayoutService.hasError = action.payload;
    })
        .addCase(setTrimCardGridNextStepUrl, function (state, action) {
        state.TrimCardGrid.nextStepUrl = action.payload;
    })
        .addCase(setNameBadge, function (state, action) {
        state.TrimOverview.nameBadge = action.payload;
    })
        .addCase(addGlobalToastNotification, function (state, action) {
        state.Global.toastNotifications = __spreadArray(__spreadArray([], state.Global.toastNotifications, true), [action.payload], false);
    })
        .addCase(removeGlobalToastNotification, function (state, action) {
        state.Global.toastNotifications = state.Global.toastNotifications.filter(function (_a) {
            var id = _a.id;
            return id !== action.payload;
        });
    })
        .addCase(setShowRecommendedWarrantyChangedToast, function (state, action) {
        state.SummaryPage.doShowRecommendedWarrantyChangedToast = action.payload;
    })
        .addCase(resetUIReducerSections, function (state, action) {
        var _a;
        if (action.payload === true) {
            return initialState;
        }
        var updatedState = {};
        // eslint-disable-next-line no-restricted-syntax
        for (var _i = 0, _b = action.payload; _i < _b.length; _i++) {
            var section = _b[_i];
            // direct property assignment throws an obscure ts error
            updatedState = __assign(__assign({}, updatedState), (_a = {}, _a[section] = initialState[section], _a));
        }
        state = __assign(__assign({}, state), updatedState);
    });
});
export var selectCurrentDrawerState = function (state) { return state.ui.ConfigureBap.currentDrawerState; };
export var selectSelectedSubCategory = function (state) { return state.ui.ConfigureBap.selectedSubCategory; };
export var selectSelectedAssetType = function (state) { return state.ui.TrimOverview.selectedAssetsType; };
export var selectInteriorColorIsInvalid = function (state) { return state.ui.TrimOverview.interiorColorIsInvalid; };
export var selectIsWarrantyOptionsModalOpen = function (state) { return state.ui.SummaryPage.isWarrantyOptionsModalOpen; };
export var selectIsPriceBreakdownModalOpen = function (state) { return state.ui.SummaryPage.isPriceBreakdownModalOpen; };
export var selectWarrantyOptionsModalKey = function (state) { return state.ui.SummaryPage.warrantyOptionsModalKey; };
export var selectWarrantyOptionsModalType = function (state) { return state.ui.SummaryPage.warrantyOptionsModalType; };
export var selectWarrantyOptionsRecommendedWarranty = function (state) {
    return state.ui.SummaryPage.warrantyOptionsRecommendedWarranty;
};
export var selectActiveProgressBarItem = function (state) { return state.ui.ConfigureBap.activeProgressBarItem; };
export var selectIsLayoutServiceSkipped = function (state) { return state.ui.LayoutService.isSkipped; };
export var selectLayoutServiceHasError = function (state) { return state.ui.LayoutService.hasError; };
export var selectLayoutServiceIsTriggered = function (state) { return state.ui.LayoutService.isTriggered; };
export var selectTrimCardGridNextStepUrl = function (state) { return state.ui.TrimCardGrid.nextStepUrl; };
export var selectNameBadge = function (state) { return state.ui.TrimOverview.nameBadge; };
export var selectCardGridType = function (state) {
    if (state.ui.ModelCardGrid.isActive)
        return CardGridType.ModelCardGrid;
    if (state.ui.TrimCardGrid.isActive)
        return CardGridType.TrimCardGrid;
    return '';
};
export var selectBapUrlQueryString = createSelector([
    selectCurrentVehicleUrlQueryString,
    selectPrimaryCalculatorQueryString,
    selectPrimaryCalculatorIncentiveOfferIdsParam,
    function (state) { return selectPaymentOptions(state, primaryCalculatorId); },
], function (currentVehicleUrlQueryString, calculatorUrlQueryString, offerKeys, paymentOptions) {
    var _a;
    var overriddenIsSellingProvince = paymentOptions.overriddenIsSellingProvince, includeFees = paymentOptions.includeFees, leaseAdditionalAnnualKm = paymentOptions.leaseAdditionalAnnualKm, leaseAnnualKmAllowance = paymentOptions.leaseAnnualKmAllowance;
    var additionalQueries = new URLSearchParams((_a = {},
        _a[OFFER_KEYS_URL_PARAM] = offerKeys,
        _a[INCLUDE_FEES_URL_PARAM] = overriddenIsSellingProvince ? 'true' : 'false',
        _a[INCLUDE_TAXES_URL_PARAM] = includeFees ? 'true' : 'false',
        _a.leaseAnnualKmAllowance = "".concat(leaseAnnualKmAllowance),
        _a.leaseAdditionalAnnualKm = "".concat(leaseAdditionalAnnualKm),
        _a));
    return "".concat(currentVehicleUrlQueryString, "&").concat(calculatorUrlQueryString, "&").concat(additionalQueries.toString());
});
export var selectTrimName = function (state) { return state.ui.TrimOverview.trimName; };
export var selectModelName = function (state) { return state.ui.TrimOverview.modelName; };
export var selectGlobalToastNotifications = function (state) { return state.ui.Global.toastNotifications; };
export var selectConfigureBapToastNotifications = function (state) { return state.ui.ConfigureBap.toastNotifications; };
export var selectDoShowSummaryRecommendedWarrantyChangedToast = function (state) {
    return state.ui.SummaryPage.doShowRecommendedWarrantyChangedToast;
};
export var comparePaymentsModalOpened = function (compareCalculatorIds) {
    return function (dispatch) {
        compareCalculatorIds.forEach(function (id) {
            dispatch(createAndHydrateCalculator(defaultDraftCalculatorId, id));
        });
        dispatch(setIsPaymentCalculatorModalOpen(false));
        dispatch(setIsCompareModalOpen(true));
    };
};
export var comparePaymentsModalClosed = function (compareCalculatorIds) {
    return function (dispatch) {
        dispatch(setIsCompareModalOpen(false));
        compareCalculatorIds.forEach(function (id) {
            dispatch(deleteCalculator(id));
        });
    };
};
export var comparePaymentsModalSubmitted = function (comparedCalculatorIds, selectedCalculatorId) {
    return function (dispatch, getState) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var transmissionKey = (_b = (_a = getState()) === null || _a === void 0 ? void 0 : _a.currentVehicle) === null || _b === void 0 ? void 0 : _b.transmissionKey;
        var paymentMethod = ((_d = (_c = getState()) === null || _c === void 0 ? void 0 : _c.financialCalculators[selectedCalculatorId]) === null || _d === void 0 ? void 0 : _d.paymentMethod) || PaymentMethod.lease;
        var offers = (_g = (_f = (_e = getState()) === null || _e === void 0 ? void 0 : _e.offers) === null || _f === void 0 ? void 0 : _f[transmissionKey]) === null || _g === void 0 ? void 0 : _g[paymentMethod];
        var selectedIncentiveOffers = (_j = (_h = getState()) === null || _h === void 0 ? void 0 : _h.financialCalculators[selectedCalculatorId]) === null || _j === void 0 ? void 0 : _j.incentiveOfferIds;
        var selectedLoyaltyOffer = (_l = (_k = getState()) === null || _k === void 0 ? void 0 : _k.financialCalculators[selectedCalculatorId]) === null || _l === void 0 ? void 0 : _l.loyaltyOfferKey;
        dispatch(hydrateFromCalculator({
            sourceId: selectedCalculatorId,
            destinationId: primaryCalculatorId,
            offerIds: (offers === null || offers === void 0 ? void 0 : offers.incentive) || [],
        }));
        dispatch(hydrateFromCalculator({
            sourceId: selectedCalculatorId,
            destinationId: defaultDraftCalculatorId,
            loyaltyOffer: (offers === null || offers === void 0 ? void 0 : offers.loyalty) || '',
        }));
        dispatch(offersPrimaryChanged({
            calculatorId: primaryCalculatorId,
            offerIds: selectedIncentiveOffers || [],
            transmissionKey: transmissionKey,
            paymentMethod: paymentMethod || PaymentMethod.lease,
        }));
        dispatch(loyaltyPrimaryChanged({
            calculatorId: primaryCalculatorId,
            offerKey: selectedLoyaltyOffer || '',
            transmissionKey: transmissionKey,
            paymentMethod: paymentMethod || PaymentMethod.lease,
        }));
        dispatch(persistCalculatorToUrl(selectedCalculatorId));
        dispatch(comparePaymentsModalClosed(comparedCalculatorIds));
    };
};
export var comparePaymentsModalAddCalculator = function (sourceId, newId) {
    return function (dispatch) {
        dispatch(createAndHydrateCalculator(sourceId, newId));
    };
};
export var showRecommendedWarrantyChangedToast = function (_a) {
    var id = _a.id, message = _a.message;
    return function (dispatch, getState) {
        var doShowRecommendedWarrantyChangedToast = getState().ui.SummaryPage.doShowRecommendedWarrantyChangedToast;
        if (doShowRecommendedWarrantyChangedToast) {
            dispatch(addGlobalToastNotification({ id: id, message: message }));
        }
    };
};
export default ui;
